import { errorText } from '@aon/aon-tws-common-ui';
import styled from 'styled-components';

export const ErrorContainer = styled.div.attrs<{}>({
	className: 'tws-error-message',
})`
	${errorText} {
		padding: 3px;
		margin-bottom: 50px;
	}
`;
ErrorContainer.displayName = 'ErrorContainer';
